<template>
  <div style="position: absolute; left:-2000px;top:-2000px;">
    <!-- SOURCE -->
    <div ref="printThis" id="print_frame" v-html="htmlCode" style="padding:15px;"/>
    <!-- OUTPUT -->
    <img :src="output">
  </div>
</template>

<script>
import jsPDF from 'jspdf';

export default {
    props: {
        filename: {
            type: String,
            required: true,
            default: 'document'
        },
        htmlCode: {
            type: String,
            required: true
        }
    },
    mounted() {
        this.print();
    },
    data() {
        return {
            output: null
        }
    },
    methods: {
        async print() {
            const el = this.$refs.printThis;
            const options = {
                type: 'dataURL'
            }
            this.output = await this.$html2canvas(el, options);
        },
        download: function(){
            var self = this;

            var element = document.getElementById('print_frame');
            var width = element.offsetWidth;
            var height = element.offsetHeight;

            var pdf = new jsPDF('landscape', undefined, [width, height]);
            var pdfWidth = pdf.internal.pageSize.getWidth();
            var pdfHeight = pdf.internal.pageSize.getHeight();
            pdf.addImage(self.output, 'PNG', 0, 0, pdfWidth, pdfHeight);
            pdf.save(`${self.filename}.pdf`, {returnPromise: true}).then(function(){
                self.$emit('close');
            },function(){
                self.customCLog('DOWNLOAD FAILED',{
                    htmlCode: self.htmlCode,
                    filename: self.filename
                }, true)
            });     
        }    
    },
    watch: {
        output: function(){
            if(this.output!=null){
                this.download();                
            }
        }
    }
}
</script>